import React from "react";
import { Outlet } from "react-router-dom";

export default function SettingsLayout() {
  return (
    <section className="settings__layout">
      <Outlet />
    </section>
  );
}
